module.exports = __webpack_public_path__ + "1eeb561746cf4ac57e35287f076389e0.svg";